import { selectHasOmsOrigins } from 'data/selectors'
import type { DetailsData } from 'data/types'
import React, { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Carousel } from 'react-responsive-carousel'
import GeneralRevenueDetails from 'revenue/GeneralRevenueDetails'
import { OrdersOriginsDetails } from 'revenue/OrdersOriginsDetails'
import ReturnsValueDetails from 'revenue/ReturnsValueDetails'
import RevenueDateDescription from 'revenue/RevenueDateDescription'
import type { State } from 'store/types'
import { getMomentDate } from 'utils'

import Divider from '@mui/material/Divider'

import { getGeneralHeaders, getReturnsHeaders } from './utils'

interface Props {
  data: DetailsData
  dataKey: string
}

function ChannelCarouselTable({ data, dataKey }: Props) {
  const { t: translate } = useTranslation()
  const hasOmsOrigins = useSelector(selectHasOmsOrigins({ dataKey }))
  const [selectedFrame, setSelectedFrame] = useState(hasOmsOrigins ? 2 : 0)
  const onChangeFrame = (index: number) => setSelectedFrame(index)
  const selectedDate = useSelector((state: State) => state.datePicker.dateCurrent)
  const headers = getGeneralHeaders(translate)
  const headersGeneral = getReturnsHeaders(translate)
  const ordersOrigins = [
    <OrdersOriginsDetails dataKey={dataKey} key="revenue" type="revenue" />,
    <OrdersOriginsDetails dataKey={dataKey} key="ordersValue" type="ordersValue" />,
  ]
  const ordersOriginsDetails = hasOmsOrigins ? ordersOrigins : ([] as any)

  return (
    <>
      <Divider />
      <Carousel
        dynamicHeight
        emulateTouch
        onChange={onChangeFrame}
        selectedItem={selectedFrame}
        showArrows={false}
        showStatus={false}
        showThumbs={false}
      >
        {ordersOriginsDetails}

        <GeneralRevenueDetails data={data} description={getMomentDate(selectedDate).format('L')} headers={headersGeneral} />

        <GeneralRevenueDetails
          data={data}
          description={<RevenueDateDescription dateCompared={data.dateCompared} dateCurrent={data.dateComparedECom} />}
          headers={headersGeneral}
          showLastYear
        />

        <ReturnsValueDetails data={data} description={getMomentDate(selectedDate).format('L')} headers={headers} />
      </Carousel>
    </>
  )
}

export default memo<Props>(ChannelCarouselTable)
